export default __webpack_public_path__ + "static/media/find-friends.69bd6bd0.svg";